export default {
  fr: {
    monthly_objective: "de l'objectif",
  },
  en: {
    monthly_objective: 'of the objective',
  },
  'pt-br': {
    monthly_objective: 'do objetivo',
  },
  es: {
    monthly_objective: 'del objetivo',
  },
  de: {
    monthly_objective: 'des Ziels',
  },
} as const
